import { Fragment } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import img1 from "../../assets/image/team_1.jpg";
import img2 from "../../assets/image/team_2.jpg";
import img3 from "../../assets/image/team_3.jpg";
import img4 from "../../assets/image/team_4.jpg";
// import img5 from "../../assets/images/brands/brand-1-2.jpg";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Teams = () => {
  // const { t } = useTranslation();
  // const { arrivals, loading } = useSelector((state) => state.homeSlicer);

  return (
    <div className="team">
      <div className="container">
        <div className="row">
          <div className="col-8 mx-auto">
            <div className="section_title_container text-center">
              <h2 className="section_title mb-4">The Best Tutors in Town</h2>
              <div className="section_subtitle">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec
                  vel gravida arcu. Vestibulum feugiat, sapien ultrices
                  fermentum congue, quam velit venenatis sem
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row team_row px-5">
          <div className="col-lg-3 col-md-6 team_col">
            <div className="team_item">
              <div className="team_image">
                <img src={img1} alt="" />
              </div>
              <div className="team_body">
                <div className="team_title">
                  <a href="#">Jacke Masito</a>
                </div>
                <div className="team_subtitle">Marketing & Management</div>
                <div className="social_list">
                  <ul>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-behance"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-linkedin"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 team_col">
            <div className="team_item">
              <div className="team_image">
                <img src={img2} alt="" />
              </div>
              <div className="team_body">
                <div className="team_title">
                  <a href="#">William James</a>
                </div>
                <div className="team_subtitle">Designer & Website</div>
                <div className="social_list">
                  <ul>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-behance"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-linkedin"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 team_col">
            <div className="team_item">
              <div className="team_image">
                <img src={img3} alt="" />
              </div>
              <div className="team_body">
                <div className="team_title">
                  <a href="#">John Tyler</a>
                </div>
                <div className="team_subtitle">Quantum mechanics</div>
                <div className="social_list">
                  <ul>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-behance"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-linkedin"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6 team_col">
            <div className="team_item">
              <div className="team_image">
                <img src={img4} alt="" />
              </div>
              <div className="team_body">
                <div className="team_title">
                  <a href="#">Veronica Vahn</a>
                </div>
                <div className="team_subtitle">Math & Physics</div>
                <div className="social_list">
                  <ul>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-behance"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-linkedin"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Teams;
